import React from 'react';
import SubHeader from '../../layout/components/SubHeader';

function CallBlast() {
    return (
        <div className="ecx-page ecx-page--full-width">
            <SubHeader
                title="Call Blast"
                description="Send marketing phone calls to your patient list."
                icon="bi-telephone-outbound"
                containerClass="w-100 px-4"
            />

            <div className="ecx-page-body">
                <div className="ecx-page-card ecx-page-panel">
                    <div className="ecx-page-empty py-5">
                        <span className="ecx-page-empty__icon">
                            <i className="bi bi-telephone-outbound" />
                        </span>
                        <h5 className="mb-2 text-dark">Call Blast coming soon</h5>
                        <p className="mb-0 text-muted">
                            This page will let you create and send call blast campaigns to your patients.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CallBlast;
